module.exports = __webpack_public_path__ + "static/media/acos.7be8f2de.png";